import type { QueryClient } from "@tanstack/react-query";
import { getTelegram } from "@/boot/telegram";

export const liveTaskQueryOptions = {
  refetchInterval: 5_000,
  refetchOnMount: "always",
  refetchOnWindowFocus: "always",
  refetchOnReconnect: "always",
} as const;

/** A Telegram tab can resume without a browser visibilitychange event. */
export function bindQueryResume(client: QueryClient): () => void {
  const refresh = () => {
    // Reuse an in-flight fetch instead of cancelling it on overlapping events.
    void client.refetchQueries({ type: "active" }, { cancelRefetch: false });
  };
  const visible = () => {
    if (document.visibilityState !== "hidden") refresh();
  };
  const tg = getTelegram();
  tg?.onEvent("activated", refresh);
  document.addEventListener("visibilitychange", visible);
  window.addEventListener("focus", visible);
  window.addEventListener("pageshow", visible);
  window.addEventListener("online", visible);
  return () => {
    tg?.offEvent("activated", refresh);
    document.removeEventListener("visibilitychange", visible);
    window.removeEventListener("focus", visible);
    window.removeEventListener("pageshow", visible);
    window.removeEventListener("online", visible);
  };
}
